import { render, staticRenderFns } from "./TournamentPrizePoolMobile.vue?vue&type=template&id=457fb0bd&scoped=true"
import script from "./TournamentPrizePoolMobile.vue?vue&type=script&lang=js"
export * from "./TournamentPrizePoolMobile.vue?vue&type=script&lang=js"
import style0 from "./TournamentPrizePoolMobile.vue?vue&type=style&index=0&id=457fb0bd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "457fb0bd",
  null
  
)

export default component.exports